import { render, staticRenderFns } from "./inspectDetail.vue?vue&type=template&id=1181a5ee&scoped=true&"
import script from "./inspectDetail.vue?vue&type=script&lang=js&"
export * from "./inspectDetail.vue?vue&type=script&lang=js&"
import style0 from "./inspectDetail.vue?vue&type=style&index=0&id=1181a5ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1181a5ee",
  null
  
)

export default component.exports